import * as React from 'react'

import * as styles from './newFeatureIndicator.module.css'

const NewFeatureIndicator = ({
  children,
  title,
  showWhen = true
}: {
  children: any
  title?: string
  showWhen?: boolean
}) => (
  <div className={styles.root}>
    {children}
    {showWhen && <div className={styles.indicator} title={title} />}
  </div>
)

export default NewFeatureIndicator
